import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';

export const HomeIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M0.5 8.99L9.5 0.52L16.5 6.87L18.5 8.99M16.5 2.64L16.5 6.87M1.5 16.93L2.5 18.52L7.5 18.52L7.5 12.17L11.5 12.17L11.5 18.52L16.5 18.52L17.5 16.93L17.5 10.58L9.5 3.17L1.5 10.58L1.5 16.93Z"
        stroke="currentColor"
        fill="none"
        strokeOpacity="1.000000"
        strokeWidth="1.000000"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};
